import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'

export const CHAT_INPUT_INNER_RADIUS = 20
const GRADIENT_BORDER_WIDTH = 2
export const CHAT_INPUT_OUTER_RADIUS = CHAT_INPUT_INNER_RADIUS + GRADIENT_BORDER_WIDTH

const GradientBorderWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: ${rem(GRADIENT_BORDER_WIDTH)};
  border-radius: ${rem(CHAT_INPUT_OUTER_RADIUS)};
  background: linear-gradient(
    135deg,
    ${props => props.theme.palette.product.ai.light} 0%,
    ${props => props.theme.palette.product.ai.dark} 50%,
    ${props => props.theme.palette.product.ai.light} 100%
  );
  box-shadow: 0 0 ${rem(8)} ${props => props.theme.palette.product.ai.light35},
              0 ${rem(2)} ${rem(12)} ${props => props.theme.palette.product.ai.dark25};

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border-radius: ${rem(CHAT_INPUT_INNER_RADIUS)};
  padding: ${rem(12)} ${rem(16)};
  gap: ${rem(8)};
  transition: padding 0.2s ease;

  &.density-compact {
    padding: ${rem(6)} ${rem(14)};
  }

  &.density-narrow {
    padding-block: ${rem(12)};
    padding-inline: ${rem(10)};
  }

  &.density-comfortable {
    padding: ${rem(20)};
  }
`

interface Props {
  density?: 'regular' | 'compact' | 'narrow' | 'comfortable'
  disabled?: boolean
  children: ReactNode
}

function ChatInputShell({ density = 'regular', disabled = false, children }: Props) {
  return (
    <GradientBorderWrapper className={clsx({ disabled })}>
      <InputContainer className={`density-${density}`}>
        {children}
      </InputContainer>
    </GradientBorderWrapper>
  )
}

export default ChatInputShell
